import { Key } from "./Key";
import { Note } from "./Note";
import DisplayConfig from "./DisplayConfig";
import {immerable} from "immer";

export interface HexMapParams{
    displayConfig:DisplayConfig,
    centerKey?:number[],
    keySingleSelect?:boolean
}

export class HexMap{
    [immerable] = true 
    static NoteXFactor:number = .866
    static NoteYFactor:number = .5
    keys:Key[][]
    notes:Note[]
    params:HexMapParams
    constructor(params:HexMapParams){
        this.params = params
        this.keys = []
        this.notes = []
    }
    getTransformDimensions = ():[compWidth:number, compHeight:number] => {
        let compWidth:number
        let compHeight:number
        const rowCt:number = this.keys.length
        const colCt:number = this.keys[0].length
        const radius:number = this.params.displayConfig.keyRadius
        if(rowCt === 1 && colCt === 1){
            compWidth = ((this.params.displayConfig.keyRadius * 2) * .866)
            compHeight = (radius * 2)
        }
        else{
            compWidth = (radius * 2 *.866 * colCt)
            compHeight = (radius * 2) + (radius * (rowCt - 1) * 1.5)  
        }
        return [Math.floor(compWidth), Math.floor(compHeight)]
    }
    getFullDimensions = (multiplier?:number)=>{
        const m:number = (multiplier !== undefined) ? multiplier : 1
        let [x,y] = this.getTransformDimensions()
        x = x + (this.params.displayConfig.getCircleRadius() * 2)
        y = y + (this.params.displayConfig.getCircleRadius() * 2)
        return [x * m, y * m]
    }
    static getVisibleKeys(map:HexMap){
        return map.keys.flat().filter((key:Key)=>{return (key.visible)})
    }
    static getVisibleNotes(map:HexMap){
        return map.notes.filter((note:Note)=>{return (note.visible)})
    }
}